import * as React from 'react';
import type { SVGProps } from 'react';
const IconApply = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconApply"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m13.514 23.375-5.477-7.411-7.412-5.477 20.75-7.862zM4.656 11.042l4.164 3.079 5.21-5.21 1.06 1.06-5.21 5.21 3.078 4.163L18.02 5.98z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconApply;
